<template>
  <!-- eslint-disable-next-line max-len -->
  <path fill-rule="evenodd" d="M20 8.8c0 .1 0 .2-.1.3L18.5 11c-.1.2-.4.2-.6.1L16.7 10v8.5c0 .2-.2.4-.4.4H12c-.2 0-.4-.2-.4-.4v-4.1c0-1-.7-1.8-1.6-1.8-.9 0-1.6.8-1.6 1.8v4.1c0 .3-.2.5-.4.5H3.7c-.2 0-.4-.2-.4-.4V10L2 11.1c-.1.1-.2.1-.3.1-.1 0-.2-.1-.3-.2L.1 9.1c-.1-.2-.1-.4 0-.6L9.7.1c.1-.1.3-.1.5 0l4.1 3.6V2.3c0-.2.2-.4.4-.4h1.6c.2 0 .4.2.4.4v3.5l3.1 2.7c.1.1.2.2.2.3" clip-rule="evenodd"/>
</template>
